<template>
    <b-badge variant="secondary">
        <span v-if="type === 'video'">
            <font-awesome-icon :icon="['fad', 'video']" fixed-width/> Video
        </span>
        <span v-if="type === 'audio'">
            <font-awesome-icon :icon="['fad', 'volume']" fixed-width/> Audio
        </span>
        <span v-if="type === 'image'">
            <font-awesome-icon :icon="['fad', 'image']" fixed-width/> Image
        </span>
        <span v-if="type === 'pdf'">
            <font-awesome-icon :icon="['fad', 'file-pdf']" fixed-width/> PDF
        </span>
        <span v-if="type === 'sims'">
            <font-awesome-icon :icon="['fad', 'code']" fixed-width/> Sims
        </span>
    </b-badge>
</template>

<script>
export default {
    props: {
        type: String,
    }
}
</script>
